var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechMolecule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neutral_12_",
    className: "st3",
    d: "M365.6,228.2c-21.2-43.5-45.2-92.7-46.4-99.6V93.8h8.6c4.8,0,8.6-3.9,8.6-8.7V50.4 c0-4.8-3.8-8.7-8.6-8.7H172.9c-4.7,0-8.6,3.9-8.6,8.7v34.7c0,4.8,3.9,8.7,8.6,8.7h8.6l0,34.1c-1.3,7.5-25.4,56.8-46.7,100.3 C86.4,327,52.2,398.5,52.2,417.7c0,40.5,39.7,40.5,71.7,40.5h252.3c31.9,0,71.7,0,71.7-40.5C447.8,398.5,413.7,327,365.6,228.2z  M181.5,76.5V59.1h137.6v17.4H181.5z M376.1,440.9H123.9c-37,0-54.5-2.3-54.5-23.1c0-16.7,48.7-116.1,80.9-181.9 c38.1-77.9,48.5-100,48.5-107.3V93.8h103.2v34.7c0,7.3,10.3,29.4,48.2,107.3c32.1,65.8,80.5,165.2,80.5,181.9 C430.6,438.6,413.2,440.9,376.1,440.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "color_1_",
    className: "st2",
    d: "M344.7,270.1c-1.7-3-5-4.7-8.4-4.4c-11.2,1.1-24.3,4.2-37.5,9.7c-7.9-27-26.4-53.4-38.2-65.7 c-2.4-2.5-6-3.3-9.2-2.1c-14.6,5.5-40.1,32.3-51.6,67.9c-12.6-4.5-24.8-7.2-34.3-8.1c-3.7-0.3-7.2,1.7-8.7,5.2 c-11.5,26.5-17.9,66.7,16.8,107.4c13.3,15.6,40.6,26.5,59.2,28c0.4,0.2,0.9,0.3,1.4,0.4c0.8,0.2,8.5,1.6,19.6,1.6 c20.2,0,51.5-4.7,73.2-30C360.1,340.9,354.7,288.3,344.7,270.1z M252.6,226.7c11,13.2,25.1,35.9,30.5,56.7 c-11,6.5-21.6,15.1-30.5,26c-9.9-11.5-23.1-20.5-36.9-27.1C224.6,253.8,242.4,234,252.6,226.7z M226.8,389.6 c-15.1-3.2-32.6-12-40.2-20.9c-21.7-25.4-27.2-53.4-16.5-83.1c22.1,3.7,55.7,16.2,72.3,38.7C232.7,341.3,226.6,362.8,226.8,389.6z  M313.8,368.6c-21,24.6-55.4,24.7-69.8,23.5c-2-85.5,65.5-104.4,87.9-108.3C337.5,300.9,339.1,339,313.8,368.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechMolecule;